import { MDBAlert, MDBBtn, MDBIcon, MDBDataTable } from "mdbreact"
import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Label, Media, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"
import { TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"
import { TAMANIO_IMG_COLUMNAS_LG, TAMANIO_IMG_COLUMNAS_SM, TAMANIO_IMG_COLUMNAS_XS } from "../../ayudas/constantes";
import { obtener_formulario_omitiendo_imagenes_ya_guardadas } from "../../ayudas/funciones"
import Lightbox from 'react-image-lightbox';
import Select from 'react-select';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';

const columns = [
    {
        label: "Asociar",
        field: "handle"
    },
    {
        label: "Estado",
        field: "asociado"
    },
    {
        label: "Empresa",
        field: "nombre"
    }
]

export default class ArticuloFormulario extends React.Component {

    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                es_material: false,
                precio: 0.0,
                costo: 0.0,
                tipo: 1,
                vendible: 1,
                cantidad: 0,
                tipo_ingreso: 1,
                taza_depreciasion: 0,
                proveedor: null,
                img_articulo: null
            },
            proveedor: {
                nombre: '',
                razon_social: '',
                nit: '',
                direccion: '',
                telefono: '',
                correo: '',
                regimen: null
            },

            etiquetaProveedor: null,
            colapsar: true,
            colapsarAsociarCategoria: true,
            colapsarAsociarEmpresa: true,
            camposRequeridos: [],
            estados: [],
            categorias: [],
            empresas: [],
            proveedores: [],
            imgNuevaArticuloBase64: null,
            verImagenEnGrande: false,
            modalAsignarProveedor: false
        };
        this.colapsarTablaAsociar = this.colapsarTablaAsociar.bind(this);
        this.asociarCategoria = this.asociarCategoria.bind(this);
        this.asociarEmpresa = this.asociarEmpresa.bind(this);
        this.almacenarRegistro = this.almacenarRegistro.bind(this);
        this.datosRegistroValidos = this.datosRegistroValidos.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.actualizarValoresProveedor = this.actualizarValoresProveedor.bind(this);
        this.cambioValores = this.cambioValores.bind(this);
    }

    componentDidMount() {
        this.obtenerAsociados();
        this.getProveedor();
        this.getEstados();
        //this.listaEmpresa();

        let registro = this.state.registro
        if (_valid(registro.id)) {
            this.imagen("/getImagen/" + registro.id, "GET", " ").then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ imgNuevaArticuloBase64: resultado.imgNuevaBase64 });
                }
            });
        }

        if (_valid(registro.id)) {
            if (_valid(registro.proveedor)) {
                this.apiRest.get('/proveedorDetalle/' + registro.proveedor).then(respuesta => {
                    if (respuesta.exitoso) {
                        let proveedor = {
                            'value': respuesta.data.id,
                            'label': respuesta.data.nombre
                        }
                        this.cambioValores(proveedor);
                    }
                });
            }
        }
    }

    //conevertir los datos en rows para la tabla 
    convertirDatos = rows => {
        rows.forEach(registro => registro.handle = this.boton(registro));
        return { columns, rows: rows };
    };

    boton = registro => [
        <MDBBtn className="waves-effect" size="sm" color="primary" title="Asociar" onClick={() => this.asociarEmpresaArticulo(registro)}>
            <MDBIcon icon="fas fa-link" />
        </MDBBtn>
    ];

    asociarEmpresaArticulo = (registro) => {
        let verificarEstado = null;
        let datos = {}
        verificarEstado = registro.asociado.props.style;

        if (_valid(verificarEstado)) {
            verificarEstado.color == '#4caf50' ?
                datos = {
                    asociar: false,
                    idEmpresa: registro.id
                }
                :
                datos = {
                    asociar: true,
                    idEmpresa: registro.id
                }

            this.asociarEntidad(datos, '/asociarArticuloEmpresa/');
        }
    }

    agregarEstado = registro => {
        registro.forEach(registro => registro.asociado = this.Estado(registro.asociado));
        return registro;
    };

    Estado = registro => {
        if (registro === true) {
            return <CheckIcon style={{ color: "#4caf50" }} />;
        } else {
            return <CancelIcon style={{ color: "#D80A2A" }} />;
        }
    }

    getEstados = () => {
        this.apiRest.get('/articuloEstados').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ estados: respuesta.data });
            }
        });
    }

    //obtener proveedor
    getProveedor = () => {
        this.apiRest.get('/proveedor').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ proveedores: this.formato(respuesta) });
            }
        });
    }

    cambioValores = asignado => {
        if (_valid(asignado)) {
            this.setState({ etiquetaProveedor: asignado });

            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['proveedor']: asignado.value }
            }));

        } else {
            this.setState({ etiquetaProveedor: asignado });
            this.setState(estadoAnterior => ({
                registro: { ...estadoAnterior.registro, ['proveedor']: undefined }
            }));
        }
    }

    imagen = async (url, method) => {
        return await fetch(process.env.REACT_APP_API_URL + url, {
            method: method
        })
            .then(async response => {
                if (response.status >= 200 && response.status < 300) {
                    return await response.json()
                        .then(dato => ({
                            exitoso: true,
                            data: dato.datosSerializados,
                            imgNuevaBase64: dato.imgNuevaArticuloBase64
                        }))
                        .catch(error => ({ exitoso: false, response, error }));
                } else if (response.status === 401) {
                    this.props.history.push('/logout');
                } else {
                    return await response.json()
                        .then(dato => ({ exitoso: false, response, data: dato }))
                        .catch(error => ({ exitoso: false, response, error }));
                }
            })
            .catch(error => ({ "exitoso": false, error }));
    }

    obtenerAsociados() {
        const { registro } = this.state;
        if (_valid(registro.id)) {
            this.apiRest.get('/articuloCategorias/' + registro.id).then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ categorias: respuesta.data });
                }
            });
            this.apiRest.get('/articuloEmpresa/' + registro.id).then(respuesta => {
                if (respuesta.exitoso) {
                    let data = this.agregarEstado(respuesta.data);
                    this.setState({ empresas: this.convertirDatos(data) });
                }
            });
            this.listaEmpresa();
        }
    }

    listaEmpresa = () =>{
        const{
            registro
        } = this.state
        this.apiRest.get('/articuloEmpresa/' + registro.id).then(respuesta => {
            if (respuesta.exitoso) {
                let data = this.cadena(respuesta.data);
                this.setState({etiquetaEmpresa: data})
            }
        });
    }

    cadena = registro =>{
        let texto = '';
        registro.forEach(registro => registro.asociado == true ? texto +=registro.nombre+' -> ': null);
        return texto;
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    colapsarTablaAsociar = estadoAColapsar => {
        this.setState(estadoAnterior => ({ ...estadoAnterior, [estadoAColapsar]: !estadoAnterior[estadoAColapsar] }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    actualizarValoresProveedor = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            proveedor: { ...estadoAnterior.proveedor, [name]: value }
        }));
    }

    actualizarValorProveedor = (name, value) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: value }
        }));
    }

    asociarCategoria = ({ target: { name, value, checked } }) => {
        const datos = {
            asociar: checked,
            idCategoria: value
        }
        this.apiRest.put('/asociarArticuloCategoria/' + this.state.registro.id, datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Categoria ' + (checked ? 'asociado' : 'desasociado') + ' exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    asociarEmpresa = ({ target: { name, value, checked } }) => {
        const datos = {
            asociar: checked,
            idEmpresa: value
        }
        this.apiRest.put('/asociarArticuloEmpresa/' + this.state.registro.id, datos).then(resultado => {
            if (resultado.exitoso) {
                toastr.success('Empresa ' + (checked ? 'asociado' : 'desasociado') + ' exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    asociarEntidad = (datos, entidadUrl) => {

        this.apiRest.put(entidadUrl + this.state.registro.id, datos).then(resultado => {
            if (resultado.exitoso) {
                this.obtenerAsociados();
                toastr.success('Empresa ' + (datos.asociar ? 'asociado' : 'desasociado') + ' exitosamente!');
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    almacenarRegistro = async () => {
        if (this.datosRegistroValidos()) {
            let registro = this.state.registro
            if (_valid(registro.id)) {
                if (!_valid(registro.fecha_compra)) {
                    delete registro.fecha_compra
                }
                if (!_valid(registro.proveedor)) {
                    delete registro.proveedor
                }
            } else {
                registro.estado = 1
            }

            let datosFormulario = new FormData();
            datosFormulario = obtener_formulario_omitiendo_imagenes_ya_guardadas(registro, "img_articulo");
            if (_valid(registro.id)) {
                this.apiRest.ArticuloFile('/articuloEditar/' + registro.id, datosFormulario, "PUT").then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.setState({ registro: resultado.data });

                        this.setState({ imgNuevaArticuloBase64: resultado.imgNuevaBase64 });

                        this.props.history.replace('/articuloFormulario');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            } else {
                this.postFileArticulo('/articulo', datosFormulario).then(resultado => {
                    if (resultado.exitoso) {
                        toastr.success('Datos almacenados exitosamente!');
                        this.setState({ registro: resultado.data });
                        this.setState({ imgNuevaArticuloBase64: resultado.imgNuevaBase64 });
                        this.obtenerAsociados();

                        this.props.history.replace('/articuloFormulario');
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }
    }

    formato = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));

    postFileArticulo(url, data) {
        return this.postArticuloFile(url, 'POST', data);
    }

    async postArticuloFile(url, method, data) {
        const auth = this.apiRest.getLS('authUser');
        const headers = {
            method: method,
            headers: { 'Authorization': 'Bearer ' + auth.access },
            body: data
        }

        return await fetch(process.env.REACT_APP_API_URL + url, headers)
            .then(async response => {
                if (response.status >= 200 && response.status < 300) {
                    return await response.json()
                        .then(dato => ({
                            exitoso: true,
                            data: dato.datosSerializados,
                            imgNuevaBase64: dato.imgNuevaArticuloBase64
                        }))
                        .catch(error => ({ exitoso: false, response, error }));
                } else if (response.status === 401) {
                    this.props.history.push('/logout');
                } else {
                    return await response.json()
                        .then(dato => ({ exitoso: false, response, data: dato }))
                        .catch(error => ({ exitoso: false, response, error }));
                }
            })
            .catch(error => ({ "exitoso": false, error }));
    }

    datosRegistroValidos() {
        const {
            codigo,
            nombre,
            tipo, estado,
            img_articulo,
            cantidad,
            tipo_ingreso,
            fecha_compra,
            proveedor
        } = this.state.registro;

        let contador = 0

        const { camposRequeridos } = this.state;
        if (!_valid(codigo)) {
            camposRequeridos.push("codigo");
        } else {
            contador += 1;
        }
        if (!_valid(nombre)) {
            camposRequeridos.push("nombre");
        } else {
            contador += 1;
        }
        if (!_valid(tipo)) {
            camposRequeridos.push("tipo");
        } else {
            contador += 1;
        }
        if (!proveedor) {
            camposRequeridos.push("proveedor");
        }else{
            contador += 1;
        }

        if (!_valid(tipo_ingreso)) {
            camposRequeridos.push("tipo de ingreso");
        } else {
            contador += 1;
        }


        this.setState({ camposRequeridos: camposRequeridos });
        setTimeout(() => this.setState({ camposRequeridos: [] }), TIEMPO_MOSTRAR_ERROR);

        if (contador === 5) {
            return true
        } else {
            return false;
        }
    }

    //imagen articulo
    actualizarImagen = ({ target: { name, files } }) => {
        this.setState(estadoAnterior => ({
            registro: { ...estadoAnterior.registro, [name]: files[0] }
        }));
    }

    //modal proveedor
    mostrarModalProveedor = () => {
        this.setState({ modalAsignarProveedor: true });
    }

    ocultarModalProveedor = () => {
        this.setState({ modalAsignarProveedor: false });
    }

    asignarProveedor = () => {
        let registro = null
        registro = this.state.proveedor

        if (_valid(this.verificarCampos(registro))) {
            this.apiRest.post('/proveedor', registro).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Proveedor creado exitosamente!');
                    this.getProveedor();
                    let proveedor = resultado.data;
                    let dato = {
                        'value': proveedor.id,
                        'label': proveedor.nombre
                    }
                    this.cambioValores(dato)
                    //this.actualizarValorProveedor(name, id);
                    this.setState({ modalAsignarProveedor: false });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
        else {
            toastr.error('Complete la informacion por favor...');
        }
    }

    verificarCampos = (filtro) => {
        let verdad = false
        let contador = 0;
        for (const property in filtro) {
            if (_valid(filtro[property])) {
                contador += 1
            } else {
                toastr.error('El campo: ' + property + ' es requerido');
            }
        }
        if (contador === 7) {
            return true;
        } else {
            return verdad
        }
    }

    actualizarPagina = () => {
        const {
            registro
        } = this.state
        for (const property in registro) {
            this.setState(estadoAnterior => ({
                registro: {
                    ...estadoAnterior.registro, [property]: ''
                }
            }));
        }
        this.setState(
            { imgNuevaArticuloBase64: null }
        )
    }

    render() {
        const {
            registro,
            colapsar,
            colapsarAsociarCategoria,
            colapsarAsociarEmpresa,
            camposRequeridos,
            categorias,
            empresas,
            imgNuevaArticuloBase64,
            verImagenEnGrande,
            proveedores,
            estados,
            proveedor,
            etiquetaProveedor
        } = this.state;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Datos" breadcrumbItem="Articulo" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Articulo</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, proporciona los datos.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <div>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="codigo" className="form-label">
                                                                        Código
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.codigo}
                                                                        onChange={this.actualizarValores}
                                                                        name="codigo"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa codigo"
                                                                        required={true}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="nombre" className="form-label" >
                                                                        Nombre
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.nombre}
                                                                        onChange={this.actualizarValores}
                                                                        name="nombre"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa nombre"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="marca" className="form-label">
                                                                        Marca
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.marca}
                                                                        onChange={this.actualizarValores}
                                                                        name="marca"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa marca"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="serie" className="form-label">
                                                                        Serie
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.serie}
                                                                        onChange={this.actualizarValores}
                                                                        name="serie"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa serie"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="descripcion" className="form-label">
                                                                        Descripción
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.descripcion}
                                                                        onChange={this.actualizarValores}
                                                                        name="descripcion"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa descripcion"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo_cuenta_contable" className="form-label">
                                                                        Tipo cuenta contable
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.tipo_cuenta_contable}
                                                                        onChange={this.actualizarValores}
                                                                        name="tipo_cuenta_contable"
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Ingresa el tipo de cuenta contable"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="precio" className="form-label">
                                                                        Valor Residual
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.precio}
                                                                        onChange={this.actualizarValores}
                                                                        name="precio"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu precio"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="costo" className="form-label">
                                                                        Costo
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.costo}
                                                                        onChange={this.actualizarValores}
                                                                        name="costo"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa tu costo"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo" className="form-label">
                                                                        Tipo
                                                                    </Label>
                                                                    <select
                                                                        value={registro.tipo}
                                                                        onChange={this.actualizarValores}
                                                                        name="tipo"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="1">Fijo</option>
                                                                        <option value="2">Funjible</option>
                                                                        {/*<option value="3">Inventarible</option>*/}
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo" className="form-label">
                                                                        Vendible
                                                                    </Label>
                                                                    <select
                                                                        value={registro.vendible}
                                                                        onChange={this.actualizarValores}
                                                                        name="vendible"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="true">Si</option>
                                                                        <option value="false">No</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="tipo_ingreso" className="form-label">
                                                                        Tipo de Ingreso
                                                                    </Label>
                                                                    <select
                                                                        value={registro.tipo_ingreso}
                                                                        onChange={this.actualizarValores}
                                                                        name="tipo_ingreso"
                                                                        className="form-control"
                                                                    >
                                                                        <option value="1">Compra</option>
                                                                        <option value="2">Ajuste de Inventario</option>
                                                                    </select>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="cantidad" className="form-label">
                                                                        Cantidad
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.cantidad}
                                                                        onChange={this.actualizarValores}
                                                                        name="cantidad"
                                                                        min="0"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa la cantidad"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="fecha_compra" className="form-label">
                                                                        Fecha de Compra
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.fecha_compra}
                                                                        onChange={this.actualizarValores}
                                                                        name="fecha_compra"
                                                                        type="date"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="taza_depreciacion" className="form-label">
                                                                        Taza de Depreciaci&oacute;n
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.taza_depreciacion}
                                                                        onChange={this.actualizarValores}
                                                                        name="taza_depreciacion"
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Ingresa la cantidad"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <MDBBtn className="waves-effect" color="dark" onClick={() => { this.mostrarModalProveedor() }}>
                                                                    <MDBIcon icon="fa fa-user" />{' '}
                                                                    Proveedor
                                                                </MDBBtn>
                                                                <p />
                                                                <Select
                                                                    name="proveedor"
                                                                    options={proveedores}
                                                                    value={etiquetaProveedor}
                                                                    onChange={this.cambioValores}
                                                                    className="basic-single"
                                                                    classNamePrefix="select"
                                                                    placeholder="Selecciona.."
                                                                    isClearable={true}
                                                                    isSearchable={true}
                                                                    noOptionsMessage={() => "No hay más opciones"}
                                                                />

                                                            </Col>
                                                            <p />
                                                            <Col lg={8}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="observaciones" className="form-label">
                                                                        Observaciones
                                                                    </Label>
                                                                    <Input
                                                                        value={registro.observaciones}
                                                                        onChange={this.actualizarValores}
                                                                        name="observaciones"
                                                                        type="textarea"
                                                                        className="form-control"
                                                                        placeholder="observaciones"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <div className="mb-3 mb-4">
                                                                    <Label htmlFor="img_articulo" className="form-label">
                                                                        Subir imagen
                                                                    </Label>
                                                                    <input
                                                                        name="img_articulo"
                                                                        className="form-control"
                                                                        type="file"
                                                                        onChange={this.actualizarImagen}
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col lg={TAMANIO_IMG_COLUMNAS_LG} sm={TAMANIO_IMG_COLUMNAS_SM} xs={TAMANIO_IMG_COLUMNAS_XS}>
                                                                <Label htmlFor="img_articulo" className="form-label">
                                                                    Imagen
                                                                </Label>
                                                                <div onClick={() => this.setState({ verImagenEnGrande: true })}>
                                                                    {imgNuevaArticuloBase64 && <img width="100%" src={`data:image/jpeg;base64,${imgNuevaArticuloBase64}`} alt="articulo" />}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    &nbsp;
                                                    <Row>
                                                        {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                                    </Row>
                                                </Form>
                                            </div>
                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/articuloListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="warning" onClick={() => this.actualizarPagina()}>
                                                        Cancelar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Guardar
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        {
                            _valid(registro.id) &&
                            <Row>
                                <Col className="col-12">
                                    <Card>
                                        <CardBody>
                                            <Link onClick={() => this.colapsarTablaAsociar("colapsarAsociarCategoria")} className="text-dark">
                                                <div className="p-4">
                                                    <Media className="d-flex align-items-center">
                                                        <div className="me-3">
                                                            <i className="uil uil-receipt text-primary h2"></i>
                                                        </div>
                                                        <div className="flex-1 overflow-hidden">
                                                            <h5 className="font-size-16 mb-1">Asociar Categoria</h5>
                                                        </div>
                                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                    </Media>
                                                </div>
                                            </Link>
                                            <Collapse isOpen={colapsarAsociarCategoria}>
                                                <div className="p-4 border-top">
                                                    <Table className="table table-sm m-0">
                                                        <thead>
                                                            <tr>
                                                                <th width="15%">Asociar</th>
                                                                <th>Categoria</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                categorias.map((categoria, indice) =>
                                                                    <tr key={indice}>
                                                                        <td className="text-center">
                                                                            <Input
                                                                                type="checkbox"
                                                                                value={categoria.id}
                                                                                onChange={this.asociarCategoria}
                                                                                defaultChecked={categoria.asociado}
                                                                                className="form-control"
                                                                            />
                                                                        </td>
                                                                        <td>{categoria.nombre}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        }
                        {
                            _valid(registro.id) &&
                            <Row>
                                <Col className="col-12">
                                    <Card>
                                        <CardBody>
                                            <Link onClick={() => this.colapsarTablaAsociar("colapsarAsociarEmpresa")} className="text-dark">
                                                <div className="p-4">
                                                    <Media className="d-flex align-items-center">
                                                        <div className="me-3">
                                                            <i className="uil uil-receipt text-primary h2"></i>
                                                        </div>
                                                        <div className="flex-1 overflow-hidden">
                                                            <h5 className="font-size-16 mb-1">Asociar empresa</h5>
                                                        </div>
                                                        <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                    </Media>
                                                </div>
                                            </Link>
                                            <Collapse isOpen={colapsarAsociarEmpresa}>
                                                <div className="p-4 border-top">
                                                    <Label htmlFor="empresaAsociada" className="form-label">
                                                        Empresas: {this.state.etiquetaEmpresa}
                                                    </Label>
                                                    {' '}
                                                    <div className="table-responsive">
                                                        <MDBDataTable hover entriesOptions={[10, 50, 100]} entries={10} searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={empresas} />
                                                    </div>
                                                </div>
                                            </Collapse>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        }
                    </Container>
                </div>
                {verImagenEnGrande && <Lightbox mainSrc={`data:image/jpeg;base64,${imgNuevaArticuloBase64}`} onCloseRequest={() => this.setState({ verImagenEnGrande: false })} />}
                {/* MODAL */}
                <Modal isOpen={this.state.modalAsignarProveedor} size="mm">
                    <ModalHeader>
                        Proveedor
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row>
                                <Col lg={4}>
                                    <div className="mb-3 mb-4">
                                        <Label htmlFor="nombre" className="form-label">
                                            Nombre
                                        </Label>
                                        <Input
                                            value={proveedor.nombre}
                                            onChange={this.actualizarValoresProveedor}
                                            name="nombre"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ingresar nombres"
                                            maxLength="150"
                                        />
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="mb-3 mb-4">
                                        <Label htmlFor="razon_social" className="form-label">
                                            Raz&oacute;n Social
                                        </Label>
                                        <Input
                                            value={proveedor.razon_social}
                                            onChange={this.actualizarValoresProveedor}
                                            name="razon_social"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ingresar Razón Social"
                                            maxLength="150"
                                        />
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="mb-3 mb-4">
                                        <Label htmlFor="nit" className="form-label">
                                            NIT
                                        </Label>
                                        <Input
                                            value={proveedor.nit}
                                            onChange={this.actualizarValoresProveedor}
                                            name="nit"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ingresar NIT"
                                            maxLength="150"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="mb-3 mb-4">
                                        <Label htmlFor="direccion" className="form-label">
                                            Direcci&oacute;n
                                        </Label>
                                        <Input
                                            value={proveedor.direccion}
                                            onChange={this.actualizarValoresProveedor}
                                            name="direccion"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ingresar direccion"
                                        />
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="mb-3 mb-4">
                                        <Label htmlFor="telefono" className="form-label">
                                            Telefono
                                        </Label>
                                        <Input
                                            value={proveedor.telefono}
                                            onChange={this.actualizarValoresProveedor}
                                            name="telefono"
                                            type="number"
                                            className="form-control"
                                            placeholder="Ingrese numero de telefono"
                                        />
                                    </div>
                                </Col>
                                <Col lg={4}>
                                    <div className="mb-3 mb-4">
                                        <Label htmlFor="correo" className="form-label">
                                            Correo Electronico
                                        </Label>
                                        <Input
                                            value={proveedor.correo}
                                            onChange={this.actualizarValoresProveedor}
                                            name="correo"
                                            type="mail"
                                            className="form-control"
                                            placeholder="Ingresar correo electronico"
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4}>
                                    <div className="mb-3 mb-4">
                                        <Label htmlFor="regimen" className="form-label">
                                            R&eacute;gimen
                                        </Label>
                                        <select
                                            value={proveedor.regimen}
                                            onChange={this.actualizarValoresProveedor}
                                            name="regimen"
                                            className="form-control"
                                        >
                                            <option value="">Seleccionar</option>
                                            <option value="0">Régimen sobre ingreso</option>
                                            <option value="1">Régimen sobre utilidades</option>
                                            <option value="2">Pequeño contribuyente</option>
                                            <option value="3">Excentos</option>
                                            <option value="4">Agente de retencion</option>
                                        </select>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect" color="success" onClick={() => this.asignarProveedor()}>
                            <MDBIcon icon="fas fa-user-check" /> {' '}
                            Guardar y Seleccionar
                        </MDBBtn>
                        <MDBBtn className="waves-effect" color="warning" onClick={() => this.ocultarModalProveedor()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }
}